import { render } from "./IconExtend.vue?vue&type=template&id=2b8f6912"
import script from "./IconExtend.vue?vue&type=script&lang=js"
export * from "./IconExtend.vue?vue&type=script&lang=js"
script.render = render

export default script